import React, { useState, useRef, useEffect } from 'react';
import { ConvertDate, ConvertObjToArrayList } from '../Tools/Converts';
import { db } from '../auth/UsersConfig/Authfirebase';
import { query, collection, getDocs, where, orderBy } from "firebase/firestore";
import BsHead from '../Tables/BsHead';
import { Table } from 'react-bootstrap';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import EditProduct from './EditProduct';

const Inventario = () => {
  const [tableInventario, setTableInventario] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [selectedCategoria, setSelectedCategoria] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const refTabInventario = useRef(null);
  const columns = ["No", "Fecha", "Nombre", "Descripcion", "Precio", "% Desc", "Cantidad Disponible", "Edit"];

  useEffect(() => {
    const initializeData = async () => {
      await fetchCategorias();
      await fetchInventario();
    };
    initializeData();
  }, []);

  useEffect(() => {
    if (selectedCategoria) {
      filterInventarioByCategoria(selectedCategoria?.value);
    } else {
      fetchInventario();
    }
  }, [selectedCategoria]);

  const fetchInventario = async () => {
    try {
      console.log("Obteniendo todo el inventario");
      const myEmpresas = collection(db, "products");
      const queryuser = query(myEmpresas, orderBy("AddRec", "desc"), where("Activo", "==", true));
      const CollectiDat = await getDocs(queryuser);

      const dat = CollectiDat.docs.map(doc => ({ data: doc.data(), Id: doc.id }));
      console.log(dat);
      setTableInventario(dat);
    } catch (err) {
      console.error("Error al obtener inventario:", err);
      alert("Error al obtener inventario: " + err.message);
    }
  };

  const fetchCategorias = async () => {
    try {
      const collectRef = collection(db, "Catalogos");
      const queryRef = query(collectRef, where('Activo', '==', true), where('NoList', '==', 2));
      const snapshot = await getDocs(queryRef);

      const datList = snapshot.docs.flatMap((doc) => ConvertObjToArrayList(doc.data().List) || []);
      setCategorias(datList.map(categoria => ({ value: categoria, label: categoria })));
    } catch (error) {
      console.error('Error al obtener categorías:', error);
      setCategorias([]);
    }
  };

  const filterInventarioByCategoria = (categoria) => {
    const filteredInventario = tableInventario.filter(item => item.data.categoria === categoria);
    setTableInventario(filteredInventario);
  };

  const handleEdit = (dt) => {
    setSelectedProduct(dt);
    setShowModal(true);
  };
  
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedProduct(null);
  }

  return (
    <div>
      <h1>Inventario</h1>
      <label>Categoría:</label>
      <Select
        options={categorias}
        placeholder="Seleccione una categoría"
        className="LtEstados"
        value={selectedCategoria}
        onChange={(option) => setSelectedCategoria(option)}
        isClearable
      />
      <Table striped bordered hover variant="light" responsive="lg" ref={refTabInventario}>
        <thead>
          <BsHead dataHeader={columns} />
        </thead>
        <tbody>
          {tableInventario.map((doc, i) => (
            <tr key={doc.Id || i}>
              <td>{tableInventario.length - i}</td>
              <td>{ConvertDate(doc.data.AddRec)}</td>
              <td>{doc.data.nombre}</td>
              <td>{doc.data.desc}</td>
              <td>{doc.data.price}</td>
              <td>{doc.data.comparePrice}</td>
              <td>{doc.data.quantity}</td>
              <td>
                <button className="bsButton" onClick={() => handleEdit(doc)}>
                  Editar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
  
      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Editar Producto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedProduct && <EditProduct productId={selectedProduct.Id} />}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Inventario;
